<template>
  <el-dialog
      :title="setId?'编辑民调':'新增民调'"
      :visible.sync="merdekaDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      width="600px"
      center>
    <el-form :model="merdekaForm" :rules="rules" ref="merdekaForm" label-width="100px">
      <el-form-item label="小区" prop="community">
        <el-select v-model="merdekaForm.community" placeholder="请选择小区" style="width: 100%;">
          <el-option
              v-for="item in communityList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="民调主体" prop="title">
        <el-input v-model="merdekaForm.title" placeholder="请输入民调主体"></el-input>
      </el-form-item>
      <el-row :gutter="20" type="flex"  justify="space-between" >
        <el-col :span="14">
          <el-form-item prop="startTime" label="民调时间">
            <el-date-picker type="date" placeholder="开始日期" class="w-all" v-model="merdekaForm.startTime"></el-date-picker>
          </el-form-item>
        </el-col>

        <el-col :span="10">
          <el-form-item prop="endTime" class="w-all" label-width="0">
            <el-date-picker type="date" placeholder="结束日期" class="w-all" v-model="merdekaForm.endTime"></el-date-picker>
          </el-form-item>
        </el-col>
        </el-row>
      <el-form-item label="备注" prop="desc">
        <el-input type="textarea" v-model="merdekaForm.desc" placeholder="请输入备注"></el-input>
      </el-form-item>
      <el-form-item class="flex align-center justify-around" label-width="0">
        <el-button class="padding-lr-xl" @click="resetForm('merdekaForm')">取消</el-button>
        <el-button class="padding-lr-xl" type="primary" @click="submitForm('merdekaForm')">提交</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import {xiaoQuList} from "@/api/community";
import {duLiMinDiaoAdd} from "@/api/merdeka";

export default {
  name: "merdekaDialog",
  props: {
    merdekaDialog: {
      type: Boolean,
      default: false
    },
    setId: {
      type: Number,
      default() {
        return 0;
      }
    },
    setItem: {
      type: Object
    }
  },
  data() {

    return {
      communityList: [],
      merdekaForm: {
        community: '',
        title: '',
        startTime: null,
        endTime: null,
        desc: ''
      },
      rules: {
        community: [{required: true, message: '请选择小区', trigger: 'change'}],
        title: [{required: true, message: '请输入民调主体', trigger: 'blur'}],
        startTime: [{type: 'date', required: true, message: '请选择开始日期', trigger: 'change'}],
        endTime: [{type: 'date', required: true, message: '请选择开始日期', trigger: 'change'}],
      }
    }
  },
  created() {
    this.getCommunityList()
  },
  computed: {
    user() {
      return this.$store.state.user
    }
  },
  methods: {
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$emit('cancelDialog', false)
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitData(formName)
        }
      });
    },
    async submitData(formName) {
      let _state = await duLiMinDiaoAdd(
          this.merdekaForm.community,
          this.merdekaForm.title,
          this.merdekaForm.startTime,
          this.merdekaForm.endTime,
          this.merdekaForm.desc,
          this.setId ? this.setId : '',
      );
      this.$message.success(_state.info);
      this.$refs[formName].resetFields();
      this.$emit("cancelDialog", true);
    },
    //  获取可民调的小区
    async getCommunityList() {
      let _data = await xiaoQuList('', 1, 1, 10000)
      this.communityList = _data.data
    },
  },
  watch: {
    setItem() {
      if (this.setId) {
        this.merdekaForm = {
          community: this.setItem.xiaoqu_id,
          title: this.setItem.mindiaozhuti,
          startTime: new Date(this.setItem.start_time),
          endTime: new Date(this.setItem.end_time),
          desc: this.setItem.beizhu
        };
      }else{
        this.merdekaForm = {
          community: '',
              title: '',
              startTime: null,
              endTime: null,
              desc: ''
        }
        this.$nextTick(() => {
          this.$refs['merdekaForm'].clearValidate();
        })
      }

    }
  }
}
</script>

<style scoped lang="scss">

</style>